const headRows = {
  file: 'Archivo',
  modifiedAt: 'Modificado en',
  size: 'Tamaño',
  download: 'Descargar',
  description: 'Descripción'
};

export default headRows;
